export const GET_FILTERS_API_REQUEST = "GET_FILTERS_API_REQUEST";
export const GET_FILTERS_API_SUCCESS = "GET_FILTERS_API_SUCCESS";
export const GET_FILTERS_API_ERROR = "GET_FILTERS_API_ERROR";